/* MR Label: Update only the detached variant box. Cassette photograph remains fixed. */
(()=>{'use strict';
const palette={
  hvit:'#ffffff',gul:'#ffdc05',svart:'#1e2329',rød:'#d13039',blå:'#2265b2',grønn:'#2d9151',
  klar:'#ecf1f2',transparent:'#ecf1f2',sølv:'#c7cbd2',gull:'#c8a545'
};
const findColor=x=>palette[String(x||'').trim().toLowerCase().replace(/^matt\s+/,'')]||'#ffffff';
const lengths={hse:'1,5 m',tze:'8 m','tze-s':'8 m','rhino-krymp':'1,5 m','rhino-poly':'5,5 m','rhino-vinyl':'5,5 m','rhino-nylon':'5,5 m'};
function init(){
 const pdp=document.querySelector('[data-pdp]'),src=document.querySelector('[data-product-json]');
 if(!pdp||!src)return;
 let data;try{data=JSON.parse(src.textContent)}catch(_){return}
 if(!data?.variants?.length)return;
 const skuField=pdp.querySelector('[data-sku]');
 const varField=pdp.querySelector('[data-variant-id]');
 const box=pdp.querySelector('[data-mr-variant-card]');
 const frame=pdp.querySelector('.fr-pdp__main');
 const img=pdp.querySelector('[data-pdp-img]'),fallback=pdp.querySelector('[data-pdp-svg]');
 const imgNote=pdp.querySelector('[data-imgnote]');
 if(!skuField||!box||!frame)return;
 const clean=pdp.dataset.mrClean==='true';
 const master=frame.dataset.masterPhoto||'';
 const fam=pdp.dataset.fam||'';
 const options=(data.options||[]).map(x=>String(x).toLowerCase());
 const widthIndex=options.findIndex(x=>x==='bredde');
 const colorIndex=options.findIndex(x=>x==='farge');
 let prev='';
 function display(){
  const sku=skuField.textContent.trim();
  const variant=data.variants.find(x=>String(x.id)===String(varField?.value))||data.variants.find(x=>x.sku===sku)||data.variants[0];
  const selected=[...pdp.querySelectorAll('[data-opt]')].map(x=>x.querySelector('[data-opt-label]')?.textContent?.trim()||'');
  const width=widthIndex>=0?(selected[widthIndex]||variant.o?.[widthIndex]||''):(selected[0]||variant.o?.[0]||'');
  const name=colorIndex>=0?(selected[colorIndex]||variant.o?.[colorIndex]||'Svart på hvit'):'Svart på hvit';
  const dim=lengths[fam]&&/mm/i.test(width)?width+' × '+lengths[fam]:width;
  if(clean&&master&&img){
    if(img.getAttribute('src')!==master)img.setAttribute('src',master);
    img.hidden=false;if(fallback)fallback.hidden=true;
  }
  const signature=[sku,dim,name].join('|');
  if(signature===prev)return;
  prev=signature;
  box.querySelector('[data-mr-sku]').textContent=sku;
  box.querySelector('[data-mr-dim]').textContent=dim;
  const swatch=box.querySelector('[data-mr-color]');
  const parts=String(name).toLowerCase().split(' på ');
  swatch.style.color=findColor(parts[0]||'svart');
  swatch.style.backgroundColor=findColor(parts[1]||'hvit');
  swatch.textContent=name.toUpperCase();
  if(imgNote){
    imgNote.hidden=false;
    imgNote.textContent=clean
      ?'Nøytralt illustrasjonsbilde av kassetten. Artikkel, bredde og farge vises i boksen under bildet.'
      :(img?.hidden?'Illustrasjon av etikett eller rull – produktfoto mangler.':'Produktfoto. Valgt variant er oppgitt under bildet.');
  }
  if(img&&clean)img.alt='Nøytral kassett til '+fam+'. Valgt '+sku+', '+dim+', '+name;
 }
 new MutationObserver(display).observe(skuField,{childList:true,subtree:true,characterData:true});
 pdp.addEventListener('click',e=>{if(e.target.closest('[data-value]'))queueMicrotask(display)});
 display();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();